import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import LoginNavigationBar from '../../Common/Layouts/NavigationBar/LoginNavigationBar';
import EnsembleLoginForm from '../Login/EnsembleLoginForm';
import Footer from '../../Common/Layouts/Footer/EnsembleFooter';
import '../../../../Assets/EnsembleStyles/EnsHome.css';
// import { getUserPreferences } from '../../../../action/cultureAction';


class EnsembleLogin extends Component {    
    componentDidMount(){
        var tenantSessionId = localStorage.getItem("tenantSessionId");        
        if(tenantSessionId !== undefined && tenantSessionId !== null)
        {
            this.setState({OnPremisesState: true});
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            OnPremisesState : false
        }
    }

    render() {
        if(this.state.OnPremisesState) {            
            return <Redirect to="/sso" />
        }

        return (             
            <div  className="ensemble_login_content">
                <LoginNavigationBar />
                <EnsembleLoginForm />
                <Footer/>
            </div>          
        );
    }
}

export default EnsembleLogin;

